import React, { useState, useEffect } from "react";
import axios from 'axios';
import GestionCorreos from "./GestionCorreos";
const ConfiguraParte = () => {
    const [configuracion, setConfiguracion] = useState(false)
    const [crearExcepcion, verCrearExcepcion] = useState(false)
    const [horaGuardia, setHoraGuardia] = useState("")
    const [horaRegular, setHoraRegular] = useState("")
    const [fechaParteAModificar, setFechaParteAModificar] = useState("")
    const [trabajando, setTrabajando] = useState(false)
   
   
    const devuelveConfiguracionParte = async () => {
        const client = axios.create({
            baseURL: "https://wwwa.isepsantafe.net.ar/expedientes/devuelveConfiguracion"
        });
        try {
            const response = await client.post('/');
       
            setConfiguracion(response.data); // Guardar los datos en el estado
        } catch (error) {
            console.error("Error al obtener la configuracion del parte:", error);
        }
    };

    // Este useEffect se ejecuta solo cuando el componente se monta
    useEffect(() => {
        devuelveConfiguracionParte();
    }, []); // El array vacío [] asegura que se ejecute solo una vez al montarse el componente

    const anulaExcepcion = async () => {
        const client = axios.create({
            baseURL: "https://wwwa.isepsantafe.net.ar/expedientes/actualizaConfiguracion"
        });
        try {
            const response = await client.post('/', { fijarseHora: "0" });
            if (response) {
//                 console.log(response.data);
                devuelveConfiguracionParte()
            } else {
//                 console.log(response.data);
            }
        } catch (error) {
            console.error("Error al obtener la configuracion del parte:", error);
        }
    }

    const modificaCorreos = async (datas) => {
        const client = axios.create({
            baseURL: "https://wwwa.isepsantafe.net.ar/expedientes/actualizaConfiguracion"
        });
        try {
            const response = await client.post('/', { correos: datas });
            if (response) {
//                 console.log(response.data);
                devuelveConfiguracionParte()
            } else {
//                 console.log(response.data);
            }
        } catch (error) {
            console.error("Error al obtener la configuracion del parte:", error);
        }
    }




    const creaExcepcion = async () => {
        const client = axios.create({
            baseURL: "https://wwwa.isepsantafe.net.ar/expedientes/actualizaConfiguracion"
        });
        try {
//             console.log(horaGuardia, horaRegular)
            const response = await client.post('/', { fijarseHora: "1", presenteGuardia: horaGuardia, presenteRegular: horaRegular });
            if (response) {
//                 console.log(response.data);
                devuelveConfiguracionParte()
            } else {
//                 console.log(response.data);
            }
        } catch (error) {
            console.error("Error al obtener la configuracion del parte:", error);
        }
    }
    const handleCreaExcepcion = () => {
        // Lógica para procesar los datos
        if (horaGuardia && horaRegular) {
            creaExcepcion()
        } else {
            alert("Por favor, complete todos los campos.");
        }
    };

    const handleModificaParte = async () => {
        if (!fechaParteAModificar) {

            alert("Por favor, complete todos los campos.");
        } else {


            setTrabajando(true)

            const client = axios.create({
                baseURL: "https://wwwa.isepsantafe.net.ar/expedientes/NCadetes/borroAusentes"
            });
            try {
//                 console.log(horaGuardia, horaRegular)
                const response = await client.post('/' + fechaParteAModificar);
                if (response) {
//                     console.log(response.data);
                    setTrabajando(false)
                } else {
//                     console.log(response.data);
                    setTrabajando(false)
                }
            } catch (error) {
                setTrabajando(false)
                console.error("Error al obtener la configuracion del parte:", error);
            }
        }
    }
    const separarEmails = (correoString) => {
        return correoString.split(';').map(correo => correo.trim());
    };




   
    return (

        <>{trabajando ? "Trabajando..." : <><div style={{ border: "#ddd 3px solid", maxWidth: "400px", display: "grid" }}>
            {configuracion ? <>
                <div>
                    {configuracion.correos? 
                        <><GestionCorreos correosString={configuracion.correos}onSave={(f)=>modificaCorreos(f)}/></>
                    : (
                        ""
                    )}
                </div>
                <div>
                    {configuracion.fijarseHora ? <><h2 style={{ color: "red" }}>Se ha establecido una generacion de partes manual para el dia de mañana</h2><h3>Horario de Guardia: {configuracion.presenteGuardia}</h3><h3>Horario de Resto F.E en todas las compañias y sedes: {configuracion.presenteRegular}</h3><div><button onClick={() => anulaExcepcion()} className="btn btn-danger">Cancelar y restaurar horario ordinario 0530 y 0600 respectivamente</button></div></> :
                        <>
                            <h4>Generacion de Partes Automaticas. Horario establecido por defecto a las 0530 horas la guardia y a las 0600 el resto de la F.E en todas las compañias y sedes </h4>
                            <div ><button className="btn btn-warning" onClick={() => verCrearExcepcion(!crearExcepcion)}>Crear Excepcion</button>{crearExcepcion ? <><div>
                                <form className="form-group">
                                    <div className="form-group">
                                        <label>PRESENTE DE GUARDIA</label>
                                        <input
                                            type="time"
                                            value={horaGuardia}
                                            onChange={(e) => setHoraGuardia(e.target.value)}
                                        /><div>
                                            <div className="form-group">
                                                <label>PRESENTE F.E</label>
                                                <input
                                                    type="time"
                                                    placeholder="Motivo"
                                                    value={horaRegular}
                                                    onChange={(e) => setHoraRegular(e.target.value)}
                                                /></div>
                                        </div>
                                    </div>
                                    <div>
                                        <input
                                            type="button"
                                            className="btn btn-success"
                                            value="Crear"
                                            onClick={handleCreaExcepcion} // Ejecutamos la función cuando se hace clic en el botón
                                        /></div>
                                </form></div></> : ""}</div>
                        </>
                    }
                </div></> : "fallo la carga"}

        </div> <div><h4>Regenera Parte</h4>
                <div>
                    <div
                        style={{
                            display: "flex",
                            justifyContent: "space-evenly",
                            alignItems: "center", // Para centrar contenido verticalmente
                            height: "100px",
                            width: "100%",

                        }}
                    >
                        {/* Aquí puedes agregar contenido como texto o componentes dentro del div */}
                        <form>
                            
                            <input
                             disabled
                                type="date"
                                value={fechaParteAModificar} // Vinculamos el estado de la fecha al valor del input
                                onChange={(e) => setFechaParteAModificar(e.target.value)} // Actualizamos el estado cuando cambia el valor
                            />

                            <input
                            disabled
                                type="button"
                                value="Rehacer Parte"
                                onClick={handleModificaParte} // Ejecutamos la función cuando se hace clic en el botón
                            />
                        </form>
                    </div>
                </div>
            </div></>}</>
    )
}
export default ConfiguraParte